import React, { FC } from "react";
import classNames from "classnames";

type Props = {
  active: string;
  options: string[];
  onUpdateActive: (active: string) => void;
};

export const Toggle: FC<Props> = ({ active, options, onUpdateActive }) => (
  <div className="flex flex-wrap items-center justify-center gap-y-2.5">
    {options.map((option) => (
      <button
        key={option}
        onClick={() => onUpdateActive(option)}
        className={classNames(
          "btn no-animation px-5 py-2.5 text-regular duration-300",
          {
            "btn-link text-primary-content no-underline hover:text-base-300 hover:no-underline":
              option !== active,
          },
        )}
        disabled={option === active}
      >
        {option}
      </button>
    ))}
  </div>
);
